/**
 * DSP API key for secure dotstudio calls.
 *
 * Order: `window.__DSP_API_KEY__` (inject in index.html / edge before the bundle) → build-time
 * `REACT_APP_DSP_API_KEY`. For production, omit the latter from the build env so the key is not
 * inside the CRA `process.env` object literal — inject `__DSP_API_KEY__` instead.
 */
const dspApiKeyFallback = process.env.REACT_APP_DSP_API_KEY || '';
if (typeof window !== 'undefined') {
  const w = window;
  const injected = w.__DSP_API_KEY__ || '';
  w.DSP_API_KEY = injected || dspApiKeyFallback;
}

export function getDspApiKey() {
  try {
    if (typeof window !== 'undefined' && window.DSP_API_KEY) {
      return window.DSP_API_KEY;
    }
  } catch {
    /* ignore */
  }
  return dspApiKeyFallback;
}
